import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { WithTheme } from './../../../setup/index'
import { NumberItemStyledProps } from './types'

const NumberItemValueStyled = styled.div`
  margin-bottom: 0.25rem;
`

const NumberItemTitleStyled = styled.div<WithTheme>`
  color: ${({ theme }) => theme.colors.green};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  text-align: center;
`

const NumberItemCaptionStyled = styled.div``

const NumberItemStyled = styled.div<WithTheme<NumberItemStyledProps>>`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.green};
  font-weight: ${({ theme }) => theme.fontWeights.bold};

  ${({ isAlt, theme }) =>
    isAlt &&
    css`
      text-align: center;
      ${NumberItemCaptionStyled} {
        color: ${theme.colors.black};
        margin-top: 1rem;
      }
      ${NumberItemCaptionStyled} span {
        line-height: 1.6;
        font-weight: 500;
      }
    `}

  ${({ isHorizontal, theme }) =>
    isHorizontal &&
    css`
      flex-direction: row;
      align-items: center;
      ${NumberItemValueStyled} {
        margin-bottom: 0;
        ${theme.direction === 'rtl' ? 'margin-left: 2.5rem;' : 'margin-right: 2.5rem;'}
      }
      ${NumberItemCaptionStyled} {
        text-align: left;
      }
    `}
`

export { NumberItemStyled, NumberItemValueStyled, NumberItemTitleStyled, NumberItemCaptionStyled }
